import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-itax-app',
  templateUrl: './itax-app.component.html',
  styleUrls: ['./itax-app.component.scss']
})
export class ItaxAppComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

  gotoAppPlay(): void {
    window.open('//bit.ly/2ugrUeM', '_blank');
  }

  gotoApp(): void {
    window.open('//apple.co/2sPConn', '_blank');
  }

}
